'use client';
import { useParams, usePathname, useRouter } from 'next/navigation';
import { UseTageaRouter } from '@web-libs/core/routing/application/use-tagea-router.concern';
import { DictionaryLocale } from '@web-libs/core/internationalization/dictionary.types';
import { hasPathLocale } from '@web-libs/core/internationalization/main';

const useCustomDomain = process.env.NEXT_PUBLIC_USE_CUSTOM_DOMAINS === 'true';

//TODO: Check compatibility with custom domain
export const useProvideTageaRouter = (): UseTageaRouter => {
  const params = useParams();
  const router = useRouter();
  const pathName = usePathname();

  const langRoute: string = params.lang ? params.lang + '/' : '';
  const langRouteWithoutSlash: string = params.lang
    ? params.lang.toString()
    : '';
  const tenantRoute = params.tenant ? params.tenant + '/' : '';
  const institutionRoute = params.institution ? params.institution + '/' : '';
  const prefixRoute = langRoute + tenantRoute + institutionRoute;

  const buildPath = (path: string) => {
    const sanitizedPath =
      path.startsWith('/') && prefixRoute.endsWith('/')
        ? path.substring(1)
        : path;
    const pathWithSlash = path.startsWith('/') ? path : `/${path}`;
    return useCustomDomain
      ? `/${langRouteWithoutSlash}${pathWithSlash}`
      : `/${prefixRoute}${sanitizedPath}`;
  };
  const push = (path: string) => {
    router.push(buildPath(path));
  };

  const getLink = (path: string) => {
    return buildPath(path);
  };

  const getFullLink = (path: string) => {
    return `${window.location.origin}${buildPath(path)}`;
  };

  const getInsitutionId = () => {
    return Array.isArray(params.institution)
      ? params.institution[0]
      : params.institution || '';
  };

  const pathname = usePathname();

  const normalize = (p: string) => {
    const hasLocale = hasPathLocale(p);
    const normalized = p.replace(/^\/|\/$/g, '');
    if (hasLocale) {
      return normalized.substring(params.lang.toString().length + 1);
    }
    return normalized;
  };

  const isCurrentPath = (path: string): boolean => {
    // Attention: IF YOU EVER NEED TO CHANGE THIS, CHECK IF ROUTING WORKS WITH CUSTOM DOMAINS AND WITHOUT
    const currentPathAfterPrefix = useCustomDomain
      ? pathname
      : pathname.replace(`/${prefixRoute}`, '');
    return normalize(currentPathAfterPrefix) === normalize(path);
  };

  const isCurrentPathOrSubPath = (path: string): boolean => {
    // Attention: IF YOU EVER NEED TO CHANGE THIS, CHECK IF ROUTING WORKS WITH CUSTOM DOMAINS AND WITHOUT
    const currentPathAfterPrefix = useCustomDomain
      ? pathname
      : pathname.replace(`/${prefixRoute}`, '');
    return normalize(currentPathAfterPrefix).startsWith(normalize(path));
  };

  const changeLanguage = (lang: DictionaryLocale) => {
    const path = pathname.substring(params.lang.toString().length + 1);
    router.push(`/${lang}${path}`);
  };

  return {
    push,
    getLink,
    getFullLink,
    getInsitutionId,
    isCurrentPath,
    isCurrentPathOrSubPath,
    changeLanguage,
  };
};
